import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class ReadMore extends Component {
  /** @param {Event} _event */
  toggle = (_event) => {
    const content = this.refs.content;
    const toggle = this.refs.toggle;
    const expanding = toggle.getAttribute('aria-expanded') !== 'true';

    toggle.setAttribute('aria-expanded', String(expanding));
    content.setAttribute('aria-hidden', String(!expanding));

    if (prefersReducedMotion()) {
      content.classList.toggle('text-block__rest--expanded', expanding);
      return;
    }

    if (expanding) {
      content.classList.add('text-block__rest--expanded');
      const height = content.scrollHeight;
      content.style.maxHeight = '0px';
      content.offsetHeight;
      content.style.maxHeight = `${height}px`;
      content.addEventListener('transitionend', () => {
        content.style.maxHeight = '';
      }, { once: true });
    } else {
      const height = content.scrollHeight;
      content.style.maxHeight = `${height}px`;
      content.offsetHeight;
      content.style.maxHeight = '0px';
      content.addEventListener('transitionend', () => {
        content.style.maxHeight = '';
        content.classList.remove('text-block__rest--expanded');
      }, { once: true });
    }
  };
}

customElements.define('read-more', ReadMore);
